// Busy-флаги для классовых React-компонентов (React 15, без хуков).
// Все флаги живут в this.state.busy (объект, не голые примитивы) и
// гарантированно сбрасываются и при успехе, и при ошибке (ошибка
// пробрасывается дальше — .catch остаётся на вызывающей стороне).
//
// Использование:
//
//   this.state = { busy: {} };
//   repeat = (id) => {
//     runBusy(this, 'repeat:' + id, () => this.props.cart.repeatOrder(id))
//       .catch(() => this.setState({ error: 'Не удалось повторить заказ' }));
//   };
//   // в render(): disabled={isBusy(this, 'repeat:' + o.id)} + класс 'is-busy'
//
// Повторный вызов с занятым ключом игнорируется (анти-дабл-клик).

export function isBusy(component, key) {
  return !!(component.state && component.state.busy && component.state.busy[key]);
}

export function runBusy(component, key, asyncFn) {
  if (isBusy(component, key)) return Promise.resolve();
  const set = (val) => {
    const busy = Object.assign({}, component.state.busy);
    busy[key] = val;
    component.setState({ busy });
  };
  set(true);
  return Promise.resolve().then(asyncFn).then(
    (res) => { set(false); return res; },
    (err) => { set(false); throw err; }
  );
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/busy.js